import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {LoadShippingFailAction, LoadShippingSuccessAction, shippingActionTypes} from '../actions/shipping-load';
import {Shipping} from '../models/shipping';
import {shippingUpdateActionTypes} from '../actions/shipping-update';

export interface ShippingState {
  shipping: Shipping;
}

const initialState: ShippingState = {
  shipping: undefined
};

export function ShippingReducer(state: ShippingState = initialState, action: Action): ShippingState {
  switch (action.type) {
    case shippingActionTypes.LOAD_SUCCESS:
    case shippingUpdateActionTypes.UPDATE_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case shippingActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case shippingActionTypes.CLEAR:
      return handleLoadClearActions(state, action);
    default:
      return state;
  }
}


function handleLoadSuccessAction(state: ShippingState, action: LoadShippingSuccessAction): ShippingState {
  const newState: ShippingState = {
    shipping: action.payload
  };
  return newState;
}

function handleLoadClearActions(state: ShippingState, action: LoadShippingFailAction): ShippingState {
  const newState: ShippingState = {
    shipping: undefined
  };
  return newState;
}

function handleLoadErrorActions(state: ShippingState): ShippingState {
  return state;
}


export const shippingSelectors = {
  shipping: (state: ShippingState) => _.get(state, 'shipping', null)
};
